import { render, staticRenderFns } from "./AuctionsPgHeader.vue?vue&type=template&id=15d0d5e7&scoped=true&"
import script from "./AuctionsPgHeader.vue?vue&type=script&lang=js&"
export * from "./AuctionsPgHeader.vue?vue&type=script&lang=js&"
import style0 from "./AuctionsPgHeader.vue?vue&type=style&index=0&id=15d0d5e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d0d5e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
